import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { Grid, Row, Col } from 'react-bootstrap';
import { withRouter } from 'react-router';
import axios from 'axios';
import analyticsContext from '../../../experiences/components/analytics/Analytics';
import OopsErrorMessage from '../../components/OopsErrorMessage/OopsErrorMessage';
import config from '../../config/config';
import REST_API_NAMES from '../../config/restApiNames';
import CheckboxSelected from '../../resources/checkboxSelected.svg';
import CheckboxUnselected from '../../resources/checkboxUnselected.svg';
import FiveEmojis from '../../resources/5Emojis.png';
import bootstrapCssUrl from '!file-loader!bootstrap/dist/css/bootstrap.min.css';
import joinResearchCSS from '!file-loader?name=[hash].css!extract-loader!css-loader!sass-loader!../../main.scss';
import { applyRequiredCapitalizations } from '../../util/TextUtils';
import { theme } from '../../../../themes';

// Sample development url : http://localhost:3000/expert-sessions/joinresearchpanel#fb7842f0-4500-11e9-9fee-19127d1b065c

class JoinResearchPanel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      optedIn: false,
      submitted: false,
      showErrorMsg: false,
      isPageDisabled: false,
    };

    this.joinResearchAPI = {
      url: config.REST_URL(REST_API_NAMES.expertSessionsJoinResearch),
      payload: {
        customerSessionId: '',
        optin: '',
        email: '',
      },
    };
  }

  componentDidMount() {
    const customerSessionId = this.props.location.hash.replace('#', '');

    analyticsContext
      .withAdvancedProps({
        section: 'joinResearchPanel',
        customerSessionId,
      })
      .screenEvent();

    if (customerSessionId) {
      this.joinResearchAPI.payload.customerSessionId = customerSessionId;
    } else {
      this.props.history.push('/');
    }
  }

  onErrorMessageOkay = (event) => {
    if (!event) {
      return;
    }
    event.preventDefault();
    this.setState({ showErrorMsg: false, isPageDisabled: false });
  };

  onSubmit = (event) => {
    if (!event) {
      return;
    }
    event.preventDefault();
    this.submitJoinResearchPanel();
  };

  submitJoinResearchPanel = () => {
    analyticsContext
      .withAdvancedProps({ section: 'JoinResearchPanel', action: 'submit', type: 'button' })
      .controlEvent();

    this.setState({ isPageDisabled: true }, () => {
      this.joinResearchAPI.payload = {
        ...this.joinResearchAPI.payload,
        optin: this.state.optedIn,
        email: this.state.email,
      };

      analyticsContext
        .withAdvancedProps({
          section: 'joinResearchPanel',
          type: 'button',
          text: 'opt in',
          action: 'joinResearch',
        })
        .controlEvent();

      axios
        .post(this.joinResearchAPI.url, this.joinResearchAPI.payload)
        .then((response) => {
          this.setState({ submitted: true, isPageDisabled: false });
        })
        .catch((error) => {
          this.setState({ showErrorMsg: true });
        });
    });
  };

  onEmailChange = (event) => {
    if (!event) {
      return;
    }
    event.preventDefault();
    const email = event.target.value;
    this.setState({ email });
  };

  onOptIn = (event) => {
    if (!event) {
      return;
    }
    event.preventDefault();
    const optedIn = !this.state.optedIn;
    this.setState({ optedIn });
  };

  isValidEmail = () => {
    const validationRegex = /^(\S+)\@(\S+)\.(\S+)$/;
    return this.state.email.match(validationRegex);
  };

  renderOopsErrorMessage = () => {
    return <OopsErrorMessage onErrorMessageOkay={this.onErrorMessageOkay} />;
  };

  render() {
    const optInDataVisibility = this.state.optedIn ? 'visible' : 'hidden';
    const submitButtonStyle = { backgroundColor: theme.colors.primaryAccent, borderColor: theme.colors.primaryAccent };
    const isSubmitButtonDisabled = !this.isValidEmail() || this.state.isPageDisabled;
    return (
      <div className="JoinResearchBackgroundContainer">
        <Grid>
          <Row>
            <Col xs={12} sm={12} md={12} lg={12}>
              <Helmet defer={false}>
                <link rel="stylesheet" type="text/css" href={bootstrapCssUrl} />
                <link rel="stylesheet" type="text/css" href={joinResearchCSS} />
              </Helmet>
              <div className="JoinResearchPanelContainer">
                <img id="FiveEmojisImage" src={FiveEmojis} alt="" />
                {!this.state.submitted && (
                  <div className="FeedbackThankYouTitle" style={{ backgroundColor: theme.colors.featureSection2 }}>
                    Thank you for providing your feedback!
                  </div>
                )}
                {this.state.submitted && (
                  <div className="ThankYou">
                    Thank you for joining our research panel! We’ll contact you when we have upcoming research
                    opportunities.
                  </div>
                )}
                {!this.state.submitted && (
                  <div className="JoinContainer">
                    <div className="JoinTitle">Join our Research Panel</div>
                    <div className="Text">
                      Would you like to share your experience using Smart Home Support products and services? Here’s
                      your chance! If you are interested in participating please opt in below and submit your email to
                      add yourself to our research panel.
                    </div>
                    <div className="radioButtonContainer">
                      <img
                        src={this.state.optedIn ? CheckboxSelected : CheckboxUnselected}
                        onClick={this.onOptIn}
                        alt=""
                      />
                      <span>Opt in to our customer research panel</span>
                    </div>
                    <div className="joinResearchPanelFormContainer" style={{ visibility: optInDataVisibility }}>
                      <input
                        name="email"
                        type="text"
                        placeholder="E-mail address"
                        value={this.state.email}
                        onChange={this.onEmailChange}
                      />
                      <button
                        onClick={this.onSubmit}
                        disabled={isSubmitButtonDisabled}
                        className={this.state.isPageDisabled ? 'waiting' : ''}
                        style={isSubmitButtonDisabled ? {} : submitButtonStyle}
                      >
                        {applyRequiredCapitalizations('Join')}
                      </button>
                    </div>
                  </div>
                )}
              </div>
              {this.state.showErrorMsg && this.renderOopsErrorMessage()}
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

export default withRouter(JoinResearchPanel);



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/experiences/pages/JoinResearchPanel/JoinResearchPanel.js